import { Component, OnInit, Renderer2 } from '@angular/core';
import { UserserviceService } from 'src/hp-app/services/userservice.service';
import { DocumentFilter } from 'src/hp-app/models/documentsfilter';
import { FormGroup, FormControl, FormBuilder, Validators, Form } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductDocument } from 'src/hp-app/models/productdocument';
import { MessageService } from 'primeng/components/common/messageservice';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '../../../models/language';
import { Location } from '@angular/common';

@Component({
  selector: 'app-products-docs',
  templateUrl: './products-docs.component.html',
  styleUrls: ['./products-docs.component.css']
})
export class ProductsDocsComponent implements OnInit {


  countryregionList: Array<any>;
  producttypeList: Array<any>;
  prdsubtypeList: Array<any>;
  productList: Array<any>;
  productDocumentsList: Array<any>;

  isproducttypedisabled = true;
  isproductsubdisabled = true;
  isproductsdisabled = true;
  ispurchasedatedisabled = true;

  iscountryactive = true;
  isproducttypeactive = false;
  isproductsubtypeactive = false;
  isproductsactive = false;
  ispurchasedateactive = false;
  isdocumentsexists = true;

  emailForm: FormGroup;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  isValidFormSubmitted = null;
  isValidEmailFormSubmitted = null;
  document_Id: number ;
  country_Id : number;
  product_Id :number;
  display: boolean = false;
  status: boolean = false;
  prevProduct: number = 0;

  selectedcountry: string;
  selectedproducttype: string;
  selectedprdsubtype: string;
  selectedproduct: string;
  selectedpurchasedate: Date;
  direction: string = "ltr";

  documentfilter: DocumentFilter = new DocumentFilter();
  selectedDocumentList: ProductDocument[] = [];
  languagelist: Array<Language> = new Array<Language>();
  languageNames: Array<string> = new Array<string>();
  language: string;

  constructor(private formBuilder: FormBuilder, private _httpuser: UserserviceService, private location: Location,
    private router: Router, private messageService: MessageService, private translate: TranslateService, private renderer: Renderer2, private route: ActivatedRoute) {

    this.language = this.route.snapshot.params["lan"];
    this.location.go("/dashboard");
    this.getLanguageList();

  }

  ngOnInit() {

      let gl = this._httpuser.getGlobalLanguage();
      if (gl.toLowerCase() == "arabic") {
        this.direction = "rtl";
      }
    this.translate.use(gl);

   

    this.getCountryList();
    this.getProductTypeList();
    this.emailForm = this.formBuilder.group({
      documentId: 0,
      countryId :0,
      productId:0,
      premail: ['', [Validators.required, Validators.pattern(this.emailPattern)]]
    });

  }


  getLanguageList() {
   
    this._httpuser.getLanguageList().subscribe(
      data => {
        this.languagelist = data
        this.languagelist.forEach(element => {
          this.languageNames.push(element.code)
        });
        if (this.language) {
          if (this.languageNames.find(s => s == this.language)) {
            this._httpuser.updateGlobalLanguage(this.language.replace(/\s/g, ""));
            let lang = this._httpuser.getGlobalLanguage();
            if (lang.toLowerCase() == "ar") {
              this.direction = "rtl";
            } else {
              this.direction = "ltr";
            }
            this.translate.use(lang.toLowerCase());
          } else {
            let lg = this._httpuser.getGlobalLanguage();
            this.translate.use(lg);
            this.router.navigate(['/dashboard']);
          }
        } else {
          let lg = this._httpuser.getGlobalLanguage();
          this.translate.use(lg);
          if (lg.toLowerCase() == "ar") {
            this.direction = "rtl";
          } else {
            this.direction = "ltr";
          }
        }
      }, err => {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err.message });
      }
    )
  }

  /**
   *  @description Method to get Country/RegionList 
   *  @author HariKiran 
   * @date 25/09/2019 
   *  @memberof ProductsDocsComponent 
   * */
  getCountryList() {
    this._httpuser.getCountryList().subscribe(
      data => {
        this.countryregionList = data;
      }, err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }

  /**
  *  @description Method to get ProductTypeList 
  *  @author HariKiran 
  *  @date 25/09/2019 
  *  @memberof ProductsDocsComponent 
  * */
  getProductTypeList() {
    this._httpuser.getProductTypeList().subscribe(
      data => {
        this.producttypeList = data;

        this.isproductsubdisabled = true;
        this.isproductsdisabled = true;
        this.ispurchasedatedisabled = true;

        this.isproductsubtypeactive = false;
        this.isproductsactive = false;
        this.ispurchasedateactive = false;

        this.prdsubtypeList = [];
        this.productList = [];

        this.selectedprdsubtype = null;
        this.selectedproduct = null;
        this.selectedpurchasedate = null;

      }, err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }

  /**
  *  @description Method to Enable ProductTypesDropDown
  *  @author HariKiran 
  *  @date 25/09/2019 
  *  @memberof ProductsDocsComponent 
  * */
  getProductTypes(event) {
    if (this.selectedcountry != null) {
      this.documentfilter.countryId = event.countryId;
      this.isproducttypedisabled = false;
      this.isproducttypeactive = true;
      this.getProductTypeList();
      this.selectedproducttype = null;
    } else {
      this.isproducttypedisabled = true; 
      this.ispurchasedateactive = true;      
      this.isproductsdisabled = true;
      this.isproductsubdisabled = true;
      
      this.ispurchasedateactive = false;
      this.isproductsactive = false;
      this.isproductsubtypeactive = false;
      this.isproducttypeactive = false;

      this.prdsubtypeList = [];
      this.productList = [];
      this.producttypeList = [];

      this.selectedprdsubtype = null;
      this.selectedproduct = null;
      this.selectedproducttype = null;
      this.selectedpurchasedate = null;
    }
    this.productDocumentsList = [];
  }

  /**
    *  @description Method to Enable ProductsubTypeListDropDown
    *  @author HariKiran 
    *  @date 25/09/2019 
    *  @memberof ProductsDocsComponent 
    * */
  getProductsubTypes(event) {
    if (this.selectedproducttype != null) {
      this.getProductsubTypeList(event);
    } else {

      this.ispurchasedateactive = false;
      this.ispurchasedatedisabled = true;
      this.isproductsactive = false;
      this.isproductsdisabled = true;
      this.isproductsubdisabled = true;
      this.isproductsubtypeactive = false;

      this.prdsubtypeList = [];
      this.productList = [];
      this.selectedprdsubtype = null;
      this.selectedproduct = null;
      this.selectedpurchasedate = null;
    }
    this.productDocumentsList = [];
  }

  /**
   *  @description Method to get ProductsubTypeList based on ProductTypeId
   *  @author HariKiran 
   *  @date 25/09/2019 
   *  @memberof ProductsDocsComponent 
   * */
  getProductsubTypeList(event) {
    if (this.selectedproducttype != null) {
      this._httpuser.getProductsubTypeList(event.productTypeId).subscribe(
        data => {
          this.prdsubtypeList = data;
          if (this.prdsubtypeList.length > 0) {
            this.isproductsubtypeactive = true;
            this.isproductsubdisabled = false;

            if (event["productTypeId"] != this.prevProduct && this.prevProduct != 0) {
              this.ispurchasedatedisabled = true;
              this.ispurchasedateactive = false;
              this.isproductsdisabled = true;
              this.isproductsactive = false;
              this.isproductsubtypeactive = true;
              this.productList = [];
              this.selectedpurchasedate = null;
              this.selectedproduct = null;
              this.selectedprdsubtype = null;
            }

          } else {
            this.isproductsubtypeactive = false;
            this.isproductsubdisabled = true;
            this.getProductsnosubType(event.productTypeId);
          }

          this.prevProduct = event["productTypeId"];
        }, err => {
          this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
        }
      )
    }

  }

  /**
   *  @description Method to Enable ProductsListDropDown
   *  @author HariKiran 
   *  @date 25/09/2019 
   *  @memberof ProductsDocsComponent 
   * */
  getProducts(event) {
    if (this.selectedprdsubtype != null) {
      this.getProductsList(event);
    }
    else {
      this.isproductsdisabled = true;
      this.isproductsactive = false;
      this.productList = [];
      this.selectedproduct = null;
    }
    this.productDocumentsList = [];
    this.ispurchasedateactive = false;
    this.ispurchasedatedisabled = true;
    this.selectedpurchasedate = null;
  }

  /**
  *  @description Method to get ProductsList based on ProductSubTypeId
  *  @author HariKiran 
  *  @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  getProductsList(event) {

    if (this.selectedprdsubtype != null) {
      this._httpuser.getProductsList(event.subProductTypeId).subscribe(
        data => {
          this.productList = data;
          if (this.productList.length > 0) {
            this.isproductsactive = true;
            this.isproductsdisabled = false;            
          }
        }, err => {
          this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
        }
      )
    }
  }

  /**
 *  @description Method to get ProductDocuments based on countryId,ProductTypeId,SubproductId,ProductId
 *  @author HariKiran 
 * @date 25/09/2019 *
 *  @memberof ProductsDocsComponent 
 * */
  getProductDocuments() {
    if (this.selectedpurchasedate != null) {
          this.productDocumentsList = [];
      this._httpuser.getProductDocuments(this.documentfilter).subscribe(
        data => {
          this.productDocumentsList = data;
        
          if (this.productDocumentsList.length > 0) {
            this.isdocumentsexists = true;
          }else{
              this.isdocumentsexists = false;
          }
        }, err => {
          this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
        }
      )
    } else {
      this.productDocumentsList = [];
    }
  }

  /**
  *  @description Method Download Document
  *  @author HariKiran 
  * @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  downLoadDocument(document) {

    let checkFileType = document["fileName"].split('.').pop();
    let file = document["fileName"];
    let fileType;
    if (checkFileType == "pdf") {
      fileType = "application/pdf";
    }
    this.documentfilter = new DocumentFilter();
    this.documentfilter.countryId = document["countryId"];
    this.documentfilter.documentId = document["documentId"];
    this.documentfilter.productId = document["productId"];

    this._httpuser.downLoadDocument(document,fileType).subscribe(
      data => {
        var downloadURL = window.URL.createObjectURL(data);
        let link =  this.renderer.createElement('a');
        link.href = downloadURL;
        link.download = file;
        link.click();
        this.messageService.add({ severity: 'success', summary: 'Downloaded successfully' });
      }, err => {
        this.messageService.add({severity:'error', summary: 'File Not Found'});
      }
    )

  }

  /**
  *  @description Method to Show Popup on Click on Email
  *  @author HariKiran 
  * @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  showDialog(document) {
    this.display = true;
    this.emailForm.reset();
    this.isValidEmailFormSubmitted = null;
    this.document_Id = document["documentId"];
    this.country_Id = document["countryId"];
    this.product_Id = document["productId"];
  }

  /**
  *  @description Method to Close Popup
  *  @author HariKiran 
  * @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  closeDailoge(){
    this.display = false;
    this.status = false;
    this.emailForm.reset();
  }
  
  /**
  *  @description Method to Send Document as Attachment as Email
  *  @author HariKiran 
  * @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  sendEmail() {

    this.isValidEmailFormSubmitted = false;
    if (this.emailForm.invalid) {
      return;
    }
    this.isValidEmailFormSubmitted = true;

    this.documentfilter = new DocumentFilter();

    this.documentfilter.email = this.emailForm.get('premail').value;
    this.documentfilter.documentId = this.emailForm.get('documentId').value;
    this.documentfilter.countryId = this.emailForm.get('countryId').value;
    this.documentfilter.productId = this.emailForm.get('productId').value;
    this.status = true;
    this._httpuser.sendEmail(this.documentfilter).subscribe(
      data => {
        this.display = false;
        this.status = false;
        this.messageService.add({severity:'success', summary: 'Email sent successfully'});
        this.emailForm.reset();
      }, err => {
        this.status = false;
        this.messageService.add({severity: 'error', summary: 'Error Message', detail: 'Internal Server Error' });
      }
    )

  }

  /**
  *  @description Method that call getdocumentbyId method
  *  @author HariKiran 
  * @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  orderFreeDelivery(documentId, countryId,productId) {
    if (documentId != 0 && countryId != 0) {
      this.documentfilter = new DocumentFilter();
      this.documentfilter.documentId = documentId;
      this.documentfilter.countryId = countryId;
      this.documentfilter.productId = productId;
      this.getdocumentbyId(this.documentfilter);
    }

  }

  /**
  *  @description Method to get Document base on documentId and storing In session storage and redirecting to checkout
  *  @author HariKiran 
  *  @date 25/09/2019 *
  *  @memberof ProductsDocsComponent 
  * */
  getdocumentbyId(doc) {
    this._httpuser.getDocumentbyId(doc).subscribe(
      data => {
        let doc = new ProductDocument();
        doc = data;
        if (sessionStorage.getItem('documentlist') != null) {

          this.selectedDocumentList = JSON.parse(sessionStorage.getItem('documentlist'));

          if (this.selectedDocumentList.find(s => s.documentId == doc.documentId && s.productName == doc.productName && s.productSubTypeName == doc.productSubTypeName && s.producttypeName == doc.producttypeName && doc.countryName == s.countryName)) {
            let quantity = this.selectedDocumentList.find(s => s.documentId == doc.documentId).quantity;

            this.selectedDocumentList.find(s => s.documentId == doc.documentId).quantity = quantity + 1;

          }
          else {
            this.selectedDocumentList.push(data); 
          }
        } else {
          this.selectedDocumentList.push(data);
        }
        
        sessionStorage.setItem('documentlist', JSON.stringify(this.selectedDocumentList));
        this.router.navigate(['/dashboard/check-out']);
      }, err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }

  get documentId() {
    return this.emailForm.get('documentId');
  }
  get premail() {
    return this.emailForm.get('premail');
  }
  get countryId(){
    return this.emailForm.get('countryId');
  }
  get productId(){
    return this.emailForm.get('productId');
  }

  getProductsnosubType(producttypeId){
    this._httpuser.getProductsnosubType(producttypeId).subscribe(
      data => {
        this.productList = data;
        if (this.productList.length > 0) {
          this.isproductsactive = true;
          this.isproductsdisabled = false;
          this.isproductsubtypeactive = false;
          this.isproductsubdisabled = true;
          this.ispurchasedateactive = false;
          this.ispurchasedatedisabled = true;
          this.selectedpurchasedate = null;
        }
      }, err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
      )
  }

  enablePurchaseDate(event) {
    this.selectedpurchasedate = null;
    this.ispurchasedateactive = true;  
    this.ispurchasedatedisabled = false;    
    this.productDocumentsList = [];
    this.documentfilter.productTypeId = event.producttypeId;

      if(event.subproducttypeId != null){
        this.documentfilter.productSubTypeId = event.subproducttypeId;
      }
      this.documentfilter.productId = event.productId;   
  }

  setPurchaseDate() {
    if(this.selectedpurchasedate != null){
      this.documentfilter.purchasedate = this.formatDateForApi(this.selectedpurchasedate);
    }
    this.getProductDocuments();
  }

  formatDateForApi(date: any): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
